import notify from "devextreme/ui/notify";

export const notifyMsg = (message, type) => {
  notify(
    {
      message: message,
      position: {
        my: "center top",
        at: "center top",
      },
    },
    type,
    3000
  );
};
